import { bool, node, number, oneOf, string } from "prop-types";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@material-ui/core";

export const TimelineUtilizationWeightTooltip = ({
  weight,
  period,
  hours,
  possibleHours,
  entityName,
  children,
  disabled,
}) => {
  const { t } = useTranslation();

  if (typeof weight !== "number" || weight === 1 || disabled || hours === 0)
    return children;

  const tooltip = "views.editor.timeline_table.utilization_weight_tooltip";
  const term = (key) => t(`views.editor.timeline_table.utilization_weight_terms.${key}`);
  const interpolation = {
    comparison: term(weight > 1 ? "exceeded" : "unused"),
    differenceHours: Math.abs(parseFloat((hours - possibleHours).toFixed(2))),
    entityName,
    period: t(`time.${period}`),
    hours,
    possibleHours,
    outcome: term(weight > 1 ? "overtime" : "bench"),
  };
  const title = (
    <>
      {t(`${tooltip}.part1`, interpolation)}
      <br />
      <br />
      {t(`${tooltip}.part2`, interpolation)}
      <br />
      {t(`${tooltip}.part3`, interpolation)}
    </>
  );

  return (
    <Tooltip arrow title={title}>
      {children}
    </Tooltip>
  );
};

TimelineUtilizationWeightTooltip.propTypes = {
  weight: number,
  period: oneOf(["month", "week", "day"]).isRequired,
  hours: number.isRequired,
  possibleHours: number.isRequired,
  entityName: string.isRequired,
  children: node.isRequired,
  disabled: bool,
};
